import type { HomePage } from '../core/types/pages'

/**
 * De homepage als één verhaal (docs/VORMGEVING.md §3): Kijken → Kiezen → Opbouwen, en tot slot
 * Kom langs. Eén bron voor de volgorde: de site rendert de blokken zo, het beheer
 * (Paginateksten › Home) toont ze zo, met hun rol en een link naar precies dat blok.
 *
 * `anchor` = het ankertje op de homepage (`/#zo-werk-ik`). De volgorde ligt vast; alleen de
 * woorden en beelden zijn beheerbaar.
 */
export type HomeSection = { key: keyof HomePage; anchor: string; title: string; role: string }

export const homeSections: readonly HomeSection[] = [
  { key: 'hero', anchor: 'opening', title: 'Opening', role: 'Wie, wat, en de knop naar het huidadvies' },
  { key: 'manifest', anchor: 'waar-ik-voor-sta', title: 'Waar ik voor sta', role: 'De balans: salon én thuis' },
  { key: 'story', anchor: 'zo-werk-ik', title: 'Zo werk ik', role: 'Kijken, Kiezen, Opbouwen, en door naar een afspraak' },
  { key: 'concerns', anchor: 'kiezen', title: 'Wat past bij jouw huid', role: 'Kiezen: per klacht het protocol voor thuis en de behandeling' },
  { key: 'protocols', anchor: 'opbouwen', title: 'Opbouwen', role: 'Wat er na je bestelling gebeurt: huidplan, bijsturen, opnieuw kijken' },
  { key: 'reviews', anchor: 'reviews', title: 'Reviews', role: 'Bewijs, de brug naar klein beginnen' },
  { key: 'bestsellers', anchor: 'een-product', title: 'Eén product', role: 'Klein beginnen: de plank met favorieten, en de cadeaus bij elke bestelling' },
  { key: 'journal', anchor: 'journal', title: 'Journal', role: 'Veelgestelde vragen, de genoemde producten, en de app-kaart' },
  { key: 'visit', anchor: 'kom-langs', title: 'Kom langs', role: 'Afsluiter: plan een afspraak' },
]

/** Het ankertje van een blok. */
export const homeAnchor = (key: keyof HomePage): string => homeSections.find((s) => s.key === key)?.anchor ?? ''
